import React from "react";

function ArrowLeftIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 9 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.5 1.25L.75 8l6.75 6.75"
      ></path>
    </svg>
  );
}

export default ArrowLeftIcon2;
